import { RouteName } from '@mews-commander/enums';
import { ResolveRoute } from '@mews/routing';
import { CommanderThunkAction } from '@mews-commander/types';
import { getBill } from '@mews-commander/legacy-entities/src/ducks/bills';
import { logBillingAction } from '../utils/logBillingAction';
import { openModal } from '../../app';

export const openProductOrderModal =
    ({ billId, serviceId }: { billId: string; serviceId?: string; scope?: string }): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const { isVirtual, ownerId } = getBill(getState(), { id: billId }) || {};

        const url = getProductOrderCreateUrl(resolveRoute)({
            billId: !isVirtual ? billId : undefined,
            serviceId,
            ownerId,
        });

        dispatch(logBillingAction('Product order modal opened'));
        return dispatch(openModal(url));
    };

export const getProductOrderCreateUrl =
    (resolveRoute: ResolveRoute) =>
    ({
        ownerId,
        serviceId,
        billId,
        guestIds,
        allowNegativeValues = true,
        onlyOfferedToEmployee = false,
    }: {
        ownerId?: string;
        serviceId?: string;
        billId?: string;
        guestIds?: string[];
        allowNegativeValues?: boolean;
        onlyOfferedToEmployee?: boolean;
    }) =>
        resolveRoute(RouteName.ProductServiceOrderCreate, {
            query: {
                retrospective: true,
                OwnerId: ownerId,
                accountId: ownerId,
                AllowNegativeValues: allowNegativeValues,
                OnlyOfferedToEmployee: onlyOfferedToEmployee,
                ...(billId ? { billId } : {}),
                ...(serviceId ? { ServiceId: serviceId } : {}),
                ...(guestIds ? { GuestIds: guestIds } : {}),
            },
        });
